<template>
  
      <ListPatient v-if="ecran =='info'"></ListPatient>
     
      <ObservationPatient v-if="ecran =='observation'"></ObservationPatient>
      <ConstantesPatient v-if="ecran =='constantes'"></ConstantesPatient>
     <PhotoPatient v-if="ecran =='photo'"></PhotoPatient>
</template>
<script>
 import ConstantesPatient from './ConstantesPatient.vue';
import ListPatient from './ListPatient.vue'
//import NouveauPatient from './NouveauPatient.vue';

import ObservationPatient from './ObservationPatient.vue';
import PhotoPatient from './PhotoPatient.vue';
export default {
  name: 'App',

  components: {
    ListPatient,
    ObservationPatient,
    ConstantesPatient,
    PhotoPatient,
    //NouveauPatient
},

  data: () => ({
    ecran:"info",
    
  }),
 methods:{
  afficherTab (){
    return true
   //return this.$route.params.id!=undefined
  }
 }

}
</script>